import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {Button, ButtonGroup} from "reactstrap";

const _time_slots = ["8AM-10AM", "9AM-12PM", "12PM-3PM", "2PM-5PM"];

const DayLayout = ({scheduleData}) => {
	return (
		<div className="row">
			{Object.entries(scheduleData).map(([feId, feData]) => (
				<div className="col-12" key={feId}>
					<h5 style={{marginTop: 0, marginBottom: 5}}>{feData.fe_name}</h5>

					<div
						style={{
							display: "flex",
							flexWrap: "wrap",
							justifyContent: "flex-start",
						}}
					>
						<ButtonGroup style={{width: "100%"}}>
							{_time_slots.map((slot) => {
								const appts = feData.appointments.filter((a) => a.slot === slot);
								const count = feData.appointments.length;

								return (
									<>
										{appts.map((item) =>
											<Button
												key={slot}
												outline
												//color={item?.is_remote ? 'warning' : item?.is_revisit ? 'danger' : 'primary'}
												color={'primary'}
												style={{width: `${100 / count}%`}}>
												<div>
													<b>{slot.replace("-", " - ")}</b>
													<div>{item ? item.ticket_cust : "-"}</div>
												</div>
											</Button>)}
									</>
								);
							})}
						</ButtonGroup>
					</div>
				</div>
			))}
		</div>
	);
};

export default DayLayout;

